import { getFullName } from '@frontend/name';
import { useSettingsNavigate } from '@frontend/settings-routing';
import { ModalControlModalProps } from '@frontend/design-system';
import { BookAppointmentModal } from '../../components/onboarding-flow-components/book-appointment-modal';
import {
  ContactDetails,
  DUMMY_CONTACT_DETAILS,
  PracticeVertical,
} from '../../components/onboarding-flow-components/constants';
import { useOnboardingFlowInfo } from '../../hooks/onboarding-flow-hooks/use-onboarding-flow-info';
import { trackOnboardingFlow } from '../../utils/track-onboarding-flow';

interface Props extends ModalControlModalProps {
  contactDetails?: ContactDetails;
  appointmentTypeName: string;
  appointmentTypeDuration: number;
}

export const BookingStep = ({
  contactDetails = DUMMY_CONTACT_DETAILS[PracticeVertical.Other],
  appointmentTypeName,
  appointmentTypeDuration,
  ...modalProps
}: Props) => {
  const { closeSettings } = useSettingsNavigate();
  const { showAppointmentFormWithInfoPrefilled } = useOnboardingFlowInfo();

  const handleBookAppointment = async () => {
    modalProps.onClose();
    closeSettings();

    showAppointmentFormWithInfoPrefilled({
      appointmentType: appointmentTypeName,
      contactName: getFullName(contactDetails),
      appointmentTypeDuration,
    });
    trackOnboardingFlow('wizardCompleted');
  };

  return (
    <BookAppointmentModal contactDetails={contactDetails} onBookAppointment={handleBookAppointment} {...modalProps} />
  );
};
